/// <amd-module name="Build/Run/Components/ArtifactStatus" />
import * as React from "react";

import { IBuildLinkingService } from "Build/Client/Linking";
import { BaseStatus, IBaseStatusOptions } from "Build/Run/Components/BaseStatus";
import * as Resources from "Build/Run/Resources";
import { usePromise } from "VSS/Core/Util/Promise";

import { ArtifactsData } from "Build/Client/Contracts/DataProvider";
import { NavConstants } from "Build/Common/Library/Constants";
import { format } from "VSS/Core/Util/String";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { useComponentContext } from "VSS/Platform/Layout";


interface IArtifactRun {
    buildId: number;
    jobIds: string[];
}

interface IArtifactStatusProps extends IBaseStatusOptions {
    rundata: IArtifactRun;
}

export const ArtifactStatus: React.FunctionComponent<IArtifactStatusProps> = props => {
    const context = useComponentContext();
    const [sources, setSources] = React.useState([] as string[]);
    const { trackPromise } = usePromise();
    const contributionService = context.pageContext.getService<IVssContributionService>("IVssContributionService");
    const linking = context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
    React.useEffect(() => {
        const runData = props.rundata;
        const params: { [key: string]: string } = {};
        params[NavConstants.buildId] = runData.buildId + "";
        trackPromise(contributionService.getDataAsync<ArtifactsData>("ms.vss-build-web.run-details-artifacts-data-provider", params, true)).then(data => {
            if (data) {
                setSources(data.sources);
            }
        });
    }, [props.rundata]);

    return <BaseStatus
        text={getText(sources, props.rundata.jobIds)}
        href={linking.getBuildUrl(props.rundata.buildId,
                NavConstants.artifacts,
                undefined,
                undefined,
                {['pathAsName']: "false"})}
        iconName="Package"
        onData={props.onData}
    />;
}

function getText(sources: string[], jobIds: string[]) {
    const count = sources.filter((s) => {
        return jobIds.indexOf(s) !== -1;
    }).length;
    if (count == 1) {
        return format(Resources.ArtifactCount, count);
    }
    else if (count > 1) {
        return format(Resources.ArtifactsCount, count);
    }
    return "";
}
